import { VueRenderer } from "@tiptap/vue-3";
import tippy, { Instance as TippyInstance } from "tippy.js";

import MergetagList from "./MergetagList.vue";
import { IMergeTag } from "../../../types/MergeTags";

interface MergetagProps {
  query: string;
}

export default (startChar: string, flatMergeTags: IMergeTag[]) => {
  return {
    char: startChar,
    items: ({ query }: MergetagProps) => {
      const mergetags = flatMergeTags;
      const filterMT: any = [];
      mergetags?.map((item) => {
        if (item.value.toLowerCase().includes(query.toLocaleLowerCase())) {
          filterMT.push(item);
        }
      });
      return filterMT.slice(0, 8);
    },

    render: () => {
      let component: VueRenderer;
      let popup: TippyInstance[];

      return {
        onStart: (props: any) => {
          component = new VueRenderer(MergetagList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          // @ts-ignore - tippy accepts string selector
          popup = tippy("body", {
            getReferenceClientRect: props.clientRect,
            appendTo: () => document.body,
            content: component.element,
            showOnCreate: true,
            interactive: true,
            trigger: "manual",
            placement: "bottom-start",
          });
        },

        onUpdate(props: any) {
          component?.updateProps(props);

          if (!props.clientRect || !popup) {
            return;
          }

          popup[0].setProps({
            getReferenceClientRect: props.clientRect,
          });
        },

        onKeyDown(props: any) {
          if (props.event.key === "Escape") {
            popup[0].hide();

            return true;
          }

          return component?.ref?.onKeyDown(props);
        },

        onExit() {
          popup[0].destroy();
          component.destroy();
        },
      };
    },
  };
};
